import { render, staticRenderFns } from "./MarkdownWrapper.vue?vue&type=template&id=7187416e&scoped=true&"
import script from "./MarkdownWrapper.vue?vue&type=script&lang=js&"
export * from "./MarkdownWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownWrapper.vue?vue&type=style&index=0&id=7187416e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7187416e",
  null
  
)

export default component.exports